import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import SaveContact from "../pages/SaveContact";
import ContactList from "../pages/ContactList";

export const Pages = () => {
  const user = localStorage.getItem("profile");
  return (
    <Switch>
      <Route path="/save-contacts">
        {user !== null ? <SaveContact /> : <Redirect to="/" />}
      </Route>
      <Route path="/contacts">
        {user !== null ? <ContactList /> : <Redirect to="/" />}
      </Route>
      <Route exact path="/">
        {user === null ? <LandingPage /> : <Redirect to="/contacts" />}
      </Route>
    </Switch>
  );
};
